import { render, staticRenderFns } from "./FastWizard.vue?vue&type=template&id=22b8d49a"
import script from "./FastWizard.vue?vue&type=script&lang=js"
export * from "./FastWizard.vue?vue&type=script&lang=js"
import style0 from "./FastWizard.vue?vue&type=style&index=0&id=22b8d49a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports